import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import './AuthStyles.css';

function AuthLayout() {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const location = useLocation();

  // Add auth-hell-body class to the body element when mounted
  useEffect(() => {
    document.body.classList.add('auth-hell-body');
    
    // Clean up function to remove the class when unmounted
    return () => {
      document.body.classList.remove('auth-hell-body');
    };
  }, []);

  const handleBackToSite = () => {
    posthog?.capture('auth_hell_back_to_site_clicked', { from: location.pathname });
    navigate('/');
  };

  return (
    <>
      <button 
        className="auth-hell-back-to-site" 
        onClick={handleBackToSite}
      >
        back to site
      </button>
      <div className="auth-hell-container">
        <Outlet />
      </div>
    </>
  );
}

export default AuthLayout; 